import './NotFound.css';
import '../GlobalPages.css';
import NavMenu from '../../components/header/navMenu/NavMenu';


export default function NotFound()
{
    return(
        <div className="PageComponent NotFoundComponent">
            <h1>Pagina não encontrada</h1>
        </div>
    )
}